import { makeVar, useReactiveVar } from '@apollo/client';
import deepEqual from 'react-fast-compare';

import type { Configuration } from '../../../types/Configuration';
import getLanguages from '../language/getLanguages';
import getCurrencies from '../currency/getCurrencies';
import getThemeVertical from '../theme/getThemeVertical';
import type Currency from '../../../types/payment/Currency';

const defaultConfiguration: Configuration = { language: '', defaultLanguage: '', pnr: '', pax: 0 };

const configuration = makeVar<Configuration>(defaultConfiguration);

/**
 * Should be used directly only for tests purposes. Use the hook otherwise
 */
export const UNSAFE_resetConfiguration = () => {
  setConfiguration(defaultConfiguration);
};

const setConfiguration = (newConfiguration: Configuration) => {
  const currentConfiguration = configuration();
  if (!deepEqual(currentConfiguration, newConfiguration)) {
    configuration(newConfiguration);
  }
};

const useAppConfig = () => {
  const config = useReactiveVar(configuration);

  return {
    actions: {
      setConfiguration,
    },
    states: {
      config,
    },
    selectors: {
      isInitialized: () => config !== defaultConfiguration,
      getLanguages: () => getLanguages(config),
      getCurrencies: () => getCurrencies(config),
      getThemeVertical: () => getThemeVertical(config),
      getForceFractionDigits: (currency: Currency) => config?.up?.currency?.currencySpecific?.find(f => f.currencyCode === currency.code)?.fractionDigits ?? config.up?.currency.global?.fractionDigits
    },
  };
};

export default useAppConfig;
